import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreEffects } from '@next/core-lib';
import { provideAgrAdvisorRelationshipsSelector } from '@next/core-lib/advisor-relationships-selector';
import { provideAgrCore } from '@next/core-lib/app';
import { I18nBrowserEffects } from '@next/core-lib/browser';
import { provideAgrElasticApi } from '@next/core-lib/elastic';
import { I18nEffects } from '@next/core-lib/i18n';
import { NavigationEffects } from '@next/core-lib/navigation';
import { provideAgrRouterStore } from '@next/core-lib/router-store';
import { SiteEffects } from '@next/core-lib/site';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';
import { provideEffects } from '@ngrx/effects';
import { provideState, provideStore } from '@ngrx/store';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HistoryModule } from './history/history.module';
import { PickUpModule } from './pick-up/pick-up.module';
import { RegistrationModule } from './registration/registration.module';
import { SharedModule } from './shared/shared.module';
import { AppEffects } from './store/effects';
import { appReducer } from './store/reducer';

@NgModule({
  declarations: [AppComponent],
  imports: [
    RouterModule,
    SharedModule,
    HistoryModule,
    RegistrationModule,
    PickUpModule,
    AppRoutingModule,
    AgrWrapperSiteSidenavModule,
  ],
  providers: [
    provideStore(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: true,
          strictActionSerializability: true,
        },
      },
    ),
    provideAgrRouterStore(),
    provideAgrCore(),
    provideAgrAdvisorRelationshipsSelector(),
    provideAgrElasticApi(),
    provideEffects([CoreEffects, I18nEffects, I18nBrowserEffects, SiteEffects, NavigationEffects]),
    provideEffects(),
    provideState('app', appReducer),
    provideEffects(AppEffects),
  ],
})
export class AppModule {}
